module.exports = __webpack_public_path__ + "static/4-22aaabc3db429adf9911d2b5e31de1d3.jpg";